/*
** qeFuncs - quantum engine functions shared js ⇆  C++
** this file generated Sun Sep 27 2026 21:44:46 GMT-0700 (Pacific Daylight Time)
** by the file SquishyElectron/quantumEngine/building/genExports.js
*/

let cwrap;
export const qeFuncs = {};

export function defineQEngineFuncs() {
// needs to run this in the app with emscripten set up for cwrap to exist
// or punt on it for node.js situations like unit tests
// eslint-disable-next-line no-restricted-globals
cwrap = globalThis.Module.cwrap;

qeFuncs.main = cwrap('main', 'number', []);
qeFuncs.startNewSpace = cwrap('startNewSpace', 'number', ['string']);
qeFuncs.addSpaceDimension = cwrap('addSpaceDimension', null, ['number','number','number','number','string']);
qeFuncs.completeNewSpace = cwrap('completeNewSpace', 'number', ['number','number']);
qeFuncs.deleteFullSpace = cwrap('deleteFullSpace', null, ['number']);
qeFuncs.getCppExceptionMessage = cwrap('getCppExceptionMessage', 'number', ['number']);
qeFuncs.qSpace_dumpVoltage = cwrap('qSpace_dumpVoltage', 'number', ['number','string']);
qeFuncs.buffer_allocateZeroedWave = cwrap('buffer_allocateZeroedWave', 'number', ['number']);
qeFuncs.buffer_allocateWave = cwrap('buffer_allocateWave', 'number', ['number']);
qeFuncs.buffer_allocateBuffer = cwrap('buffer_allocateBuffer', 'number', ['number']);
qeFuncs.cavity_normalize = cwrap('cavity_normalize', null, ['number']);
qeFuncs.cavity_create = cwrap('cavity_create', 'number', ['number','number']);
qeFuncs.cavity_delete = cwrap('cavity_delete', null, ['number']);
qeFuncs.avatar_create = cwrap('avatar_create', 'number', ['string']);
qeFuncs.avatar_setCavitySpace = cwrap('avatar_setCavitySpace', null, ['number','number','number']);
qeFuncs.avatar_attachViewBuffer = cwrap('avatar_attachViewBuffer', 'number', ['number','number','number','number']);
qeFuncs.avatar_attachIndexBuffer = cwrap('avatar_attachIndexBuffer', 'number', ['number','number','number']);
qeFuncs.avatar_dumpMeta = cwrap('avatar_dumpMeta', null, ['number','string']);
qeFuncs.avatar_dumpEachViewBuffer = cwrap('avatar_dumpEachViewBuffer', null, ['number','number','string']);
qeFuncs.avatar_dumpComplexViewBuffer = cwrap('avatar_dumpComplexViewBuffer', null, ['number','number','number','string']);
qeFuncs.avatar_dumpIndex = cwrap('avatar_dumpIndex', null, ['number','string']);
qeFuncs.avatar_getViewBuffer = cwrap('avatar_getViewBuffer', 'number', ['number','number']);
qeFuncs.avatar_avFlatLoader = cwrap('avatar_avFlatLoader', null, ['number','number','number','number']);
qeFuncs.grinder_create = cwrap('grinder_create', 'number', ['number','number','string']);
qeFuncs.grinder_delete = cwrap('grinder_delete', null, ['number']);
qeFuncs.grinder_triggerIteration = cwrap('grinder_triggerIteration', null, ['number']);
qeFuncs.grinder_oneLap = cwrap('grinder_oneLap', null, ['number']);
qeFuncs.grinder_askForFFT = cwrap('grinder_askForFFT', null, ['number']);
qeFuncs.grinder_getExceptionMessage = cwrap('grinder_getExceptionMessage', 'string', []);
qeFuncs.thread_setupThreads = cwrap('thread_setupThreads', 'number', []);

}

globalThis.defineQEngineFuncs = defineQEngineFuncs;  // just in case
globalThis.qeFuncs = qeFuncs;

export default qeFuncs;

